var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2212_1458)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#paint0_linear_2212_1458)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2212_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.0874 81.9076L63.9272 74.3456C62.4974 73.6315 61.6087 72.197 61.6087 70.601V65.2478C61.9721 64.8044 62.3546 64.2993 62.7497 63.742C64.716 60.9712 66.2918 57.8868 67.4376 54.5603C69.6768 53.5358 71.1304 51.3271 71.1304 48.8333V42.5C71.1304 40.9753 70.5591 39.498 69.5435 38.3438V29.922C69.6323 29.0512 69.9815 23.8673 66.2236 19.5907C62.964 15.881 57.6746 14 50.5 14C43.3254 14 38.036 15.881 34.7764 19.5892C31.0185 23.8657 31.3677 29.0512 31.4565 29.922V38.3438C30.4409 39.498 29.8696 40.9753 29.8696 42.5V48.8333C29.8696 50.7603 30.7472 52.5573 32.2452 53.7559C33.6989 59.4987 36.7411 63.8259 37.8043 65.2145V70.4538C37.8043 71.9864 36.9664 73.3924 35.6191 74.1271L21.4619 81.8316C16.8581 84.338 14 89.1418 14 94.3732V100C14 100 37.8758 100 50.5 100C63.1242 100 87 100 87 100V94.6819C87 89.2384 83.9673 84.3428 79.0874 81.9076Z",
    fill: "url(#paint1_linear_2212_1458)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2212_1458",
    x: 9,
    y: 9,
    width: 93,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2212_1458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2212_1458",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2212_1458",
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244578"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2212_1458",
    x1: 12.5,
    y1: 54.5,
    x2: 87,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4DEE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2212_1458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/defaultAvatar.c05e5fdc9b96fdeed84ac548f6844315.svg";
export { ForwardRef as ReactComponent };